import { loadYmap } from 'vue-yandex-maps';

document.addEventListener(
    'DOMContentLoaded',
    () => {
        const mapBlock = document.querySelector('.js-ymap');
        if (mapBlock !== undefined && mapBlock !== null) {
            const mapInit = async () => {
                await loadYmap({
                    apiKey: mapBlock.getAttribute('data-api-key'),
                    lang: 'ru_RU',
                    coordorder: 'latlong',
                    enterprise: false,
                    version: '2.1',
                });

                const myMap = new ymaps.Map(mapBlock.getAttribute('id'), {
                    center: [55.75399399999374, 37.62209300000001],
                    zoom: 10,
                    controls: ['smallMapDefaultSet'],
                });

                let myGeoObjects: any[] = [];

                const showGeoObjects = (i: number) => {
                    myMap.geoObjects.removeAll();
                    myGeoObjects = [];

                    const mapSections =
                        mapBlock.querySelectorAll('.ymap__section');
                    mapSections.forEach((section, index) => {
                        if (i === index) {
                            const mapItems =
                                section.querySelectorAll('.ymap__item');
                            mapItems.forEach((item, index2) => {
                                const coordinates = item
                                    .getAttribute('data-coordinates')
                                    .split(',');
                                myGeoObjects.push({
                                    type: 'Feature',
                                    geometry: {
                                        type: 'Point',
                                        coordinates,
                                    },
                                    options: {
                                        iconLayout: 'default#image',
                                        iconImageHref:
                                            item.getAttribute('data-pin'),
                                        iconImageSize: [40, 48],
                                        iconImageOffset: [-20, -48],
                                        hasHint: true,
                                    },
                                    properties: {
                                        clusterCaption:
                                            item.getAttribute('data-name'),
                                        balloonContentBody: item.innerHTML,
                                        hintContent:
                                            item.getAttribute('data-name'),
                                    },
                                });
                            });

                            const ans = `{"type": "FeatureCollection", "features": ${JSON.stringify(
                                myGeoObjects,
                            )}}`;

                            const result = ymaps.geoQuery(myMap.geoObjects);
                            const extendedResult = result.add(ans);

                            const clusterer = extendedResult
                                .search('geometry.type == "Point"')
                                .clusterize({
                                    gridSize: 50,
                                    minClusterSize: 2,
                                    clusterIconColor: '#1A3D20',
                                    zoomMargin: 50,
                                });
                            myMap.geoObjects.add(clusterer);

                            myMap.setBounds(extendedResult.getBounds(), {
                                checkZoomRange: true,
                                zoomMargin: 50,
                            });

                            const setMapCenter = () => {
                                if (extendedResult._objects.length > 1) {
                                    myMap.setBounds(
                                        extendedResult.getBounds(),
                                        {
                                            checkZoomRange: true,
                                            zoomMargin: 50,
                                        },
                                    );
                                } else if (
                                    extendedResult._objects.length === 1
                                ) {
                                    setTimeout(() => {
                                        myMap.setZoom(13);
                                    }, 100);
                                }
                            };

                            setMapCenter();
                        }
                    });
                };

                showGeoObjects(0);

                const centerLinks =
                    document.querySelectorAll('.js-map-set-center');
                centerLinks.forEach((link, index) => {
                    link.addEventListener('click', (e) => {
                        e.preventDefault();
                        const coordinates = link
                            .getAttribute('data-coordinates')
                            .split(',');
                        myMap.setCenter(coordinates);
                    });
                });

                mapBlock.addEventListener('setTab', (e) => {
                    showGeoObjects(e.detail);
                });
            };
            mapInit();
        }
    },
    { once: true },
);
